import module from 'empresa/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('empresa.informacion.direcciones', {
    url: '/direcciones',
    data: {title: 'Direcciones'},
    views: {
      '@empresa': {
        template: '<empresa-informacion-direcciones empresa-id="empresaId"></empresa-informacion-direcciones>',
        controller: ($scope, empresaId) => {
          $scope.empresaId = empresaId
        },
        resolve: {
          empresaId: ($stateParams) => $stateParams.empresa_id,
        },
      },
    },
  })
})



// WEBPACK FOOTER //
// ./src/empresa/routes/empresa/informacion/direcciones.js